import React from "react";
import { connect } from "react-redux";

import { getSchoolNoticeIDList, getSchoolByID , getGoToNoticeID } from "state/teachers/selectors";
import { clearGoToNotice } from "state/teachers/actions";

import ScrollableList from "components/ScrollableList";
import List from "components/List";
import PlaceholderCard from "components/teachers/PlaceholderCard";
import Notice from "components/teachers/noticeboard/Notice";

class SchoolNoticeList extends React.Component {
  
  render() {
    
    const { noticeIDList, school, goToNoticeID } = this.props;
    
    const placeholder = <PlaceholderCard school={school} objectName="notices" />;
    
    return (
      <ScrollableList className="notice-list" onScroll={this.props.clearGoTo} scrollTargetID={goToNoticeID}>
        { refChild => (
          <List placeholder={placeholder}>
            { noticeIDList.map(noticeID => (
              <Notice key={noticeID} noticeID={noticeID} innerRef={child => refChild(child, noticeID)} />
            )) }
          </List>
        ) }
      </ScrollableList>
    );
    
  }
  
}

export default connect(
  (state, { schoolID }) => ({
    noticeIDList: getSchoolNoticeIDList(state, schoolID),
    school: getSchoolByID(state, schoolID),
    goToNoticeID: getGoToNoticeID(state)
  }), {
    clearGoTo: clearGoToNotice
  }
)(SchoolNoticeList);



// WEBPACK FOOTER //
// ./src/components/teachers/noticeboard/SchoolNoticeList.js